<template>
  <div id="app">
    <div :class="getSiteContent()" :style="{ backgroundImage: 'url(' + getBackgroundPattern() + '), linear-gradient(#154F68, #497487)' }" role="main">
      <!--<div v-show="showLineBanner()" class="bottom-right">
                <img :src="lineBanner" alt="">
            </div>-->
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  watch: {
    // call method if the route changes
    $route: "onRouteChanged",
  },
  created() {
    this.loadFromLocalStorage();
  },
  data() {
    return {
      // Text

      // Images
      //topBanner: require("@/assets/menus/main/background_top.png"),
      lineBanner: require("@/assets/menus/lineBanner.png"),
      motifs: require("@/assets/menus/main/motifs-form.png"),
      patterns: require("@/assets/menus/main/background_bottom_white.png"),
    };
  },
  methods: {
    getBackgroundPattern() {
      if (this.$route.name == "home") {
        if (this.newVersion()) {
          return "";
        }
        return this.patterns;
      }

      if (this.newVersion()) {
        // TBD - keep this out for now until we decide
        return "";
        //return this.motifs;
      }

      return this.lineBanner;
    },
    getSiteContent() {
      if (this.$route.name == "home") {
        if (this.newVersion()) {
          return "site-content-purple-new";
        } else {
          return "site-content";
        }
      }
      if (this.newVersion()) {
        if (this.$route.name == "tutorial") {
          return "site-content-purple-new";
        } else {
          return "site-content-behind";
        }
      }
      return "site-content-purple";
    },
    onRouteChanged() {
      //console.log("Route changed to: " + this.$route.name);
      // Unregister the saved audio id since we just opened a new page
      this.$store.commit("setRegisteredAudioId", "");
    },
    showLineBanner() {
      // Don't show the bottom right banner on homescreen but show it everywhere else
      if (this.$route.name == "home" || this.$route.name == "register" || this.$route.name == "intervention") {
        return false;
      }
      return true;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Nunito");
@import url("https://fonts.googleapis.com/css?family=Poppins");

.site-content {
  background-color: #154f68;
  position: absolute;
  width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
}
.site-content-behind {
  background-color: #cbdbe2;
  background-image: linear-gradient(#cbdbe2, #ebf1f4) !important;
  position: absolute;
  width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
}

.site-content-purple {
  position: absolute;
  width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
  background-color: #07415b !important;
  background-repeat: repeat-x;
  background-position: bottom;
}

.site-content-purple-new {
  position: absolute;
  width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
  /*background-color: #154F68 !important;*/
  background-image: linear-gradient(#cbdbe2, white) !important;
  background-repeat: no-repeat !important;
  background-position: 75% 75%;
}

.site-content-transparent {
  background-color: transparent !important;
}
.img-stretch {
  width: 100%;
}
.img-bottom {
  position: absolute;
  width: 100%;
  bottom: 0px;
}
.centered-element {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.bottom-right {
  position: absolute;
  bottom: 0px;
  right: 0px;
}

h1 {
  font-size: 28px !important;
  font-weight: bold;
}

h2 {
  font-size: 18px !important;
  font-weight: bold;
}

h3 {
  font-size: 16px !important;
  font-weight: bold;
}

h4 {
  font-size: 24px !important;
}

strong {
  /* 16 * 0.0625 = 1px */
  letter-spacing: 1px;
}

.funky-shape {
  width: 160px;
  min-height: 50px;
  clip-path: polygon(10% 20%, 85% 0%, 100% 100%, 0% 100%);
  background-color: #3f5d12;
  color: white;
  text-align: center;
  font-family: "Poppins";
}

.site-background {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 1400px;
  min-height: 800px;
  background-color: transparent;
  padding: 10px;
}

span + span {
  margin-left: 20px;
}

a:link {
  color: blue !important;
  text-decoration: none !important;
}

a:visited {
  color: blue !important;
  text-decoration: none !important;
}

a:hover {
  color: darkslateblue;
}

a:active {
  color: darkslateblue;
}
</style>
